














import { Component, Prop, Vue } from 'vue-property-decorator'

export type TabOption = { link: string; name: string }

@Component
export default class TabBase extends Vue {
  @Prop()
  tabs!: TabOption[]

  @Prop()
  type?: string

  @Prop()
  width?: string

  get classObject(): string {
    const { type } = this
    return type || 'button-center'
  }

  get baseStyles(): { [key: string]: string } {
    return {
      '--width': this.width ? this.width : '50px',
    }
  }

  private get linkActive() {
    return this.$route.path
  }

  private transition(link: string) {
    this.$router.push(link)
  }
}
